var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserProfileMinus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.875 18L1.87534 14.9997C1.87552 13.3429 3.21861 12 4.87534 12H10.375M18.125 13H13.625M11.875 5C11.875 6.65685 10.5319 8 8.875 8C7.21814 8 5.875 6.65685 5.875 5C5.875 3.34315 7.21814 2 8.875 2C10.5319 2 11.875 3.34315 11.875 5Z",
    stroke: "#FF2C2C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserProfileMinus);
export default __webpack_public_path__ + "static/media/user-profile-minus.41f1897e31c39327f573d11e8a5b0950.svg";
export { ForwardRef as ReactComponent };